// Header Show After 10 Second
window.addEventListener('load', function () {
 /*   setTimeout(function () {
        document.querySelector('.header_sec').style.display = 'block';
    }, 6000); */
    setTimeout(function () {
        document.querySelector('.stick_btn').style.display = 'block';
    }, 6000);    
});

// Radio Active Class Add
document.querySelectorAll('.form-check-input').forEach(radio => {
    radio.addEventListener('change', function () {

        document.querySelectorAll('.form-check').forEach(item => {
            item.classList.remove('active');
        });

        this.closest('.form-check').classList.add('active');
    });
});

// Review Slider
$(".review-slider").slick({
    slidesToShow: 1,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    dots: true,
    centerMode: true,
    centerPadding: '450px',
    responsive: [{
        breakpoint: 1580,
        settings: {
        slidesToShow: 1,
        centerPadding: '250px',
        }
    },
    {
        breakpoint: 1200,
        settings: {
            slidesToShow: 1,
            centerPadding: '150px',
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            centerPadding: '0',
        }
    }]
});

// Smooth Slider
 $('.smooth-slider-text').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.smooth-slider'
});

$(".smooth-slider").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    arrows: false,
    centerMode: true,
    asNavFor: '.smooth-slider-text',
    responsive: [{
        breakpoint: 767,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1
        }
    },
    {
        breakpoint: 400,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
});